export default {
  editStoryHeader: {
    id: 'EDIT-STORY-SUMMARY_HEADER',
    defaultMessage: 'Summary',
    description:
      'Campaigns > Story Kit > Story Edit Page: click on summary to edit displays header',
  },
};
